import React from 'react';
import { Progress } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/modules/progress.less';

export default Progress;
